import React, { useState } from 'react';
import './App.css';
import LoginScreen from './components/LoginScreen';
import Dashboard from './components/Dashboard';

// Public demo user (safe to commit to GitHub)
const publicUsers = [
  { username: 'guest', password: 'demo', displayName: 'Guest (Demo)', isGuest: true }
];

// Real user credentials from environment variables (not committed to repo)
// Create a .env file with: REACT_APP_USER_JACKSON and REACT_APP_USER_GENNA
// Format: username:password:displayName
const privateUsers = [];

if (process.env.REACT_APP_USER_JACKSON) {
  const [username, password, displayName] = process.env.REACT_APP_USER_JACKSON.split(':');
  privateUsers.push({ username, password, displayName });
}

if (process.env.REACT_APP_USER_GENNA) {
  const [username, password, displayName] = process.env.REACT_APP_USER_GENNA.split(':');
  privateUsers.push({ username, password, displayName });
}

const users = [...publicUsers, ...privateUsers];

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  const handleLogin = (username, password) => {
    const user = users.find(u => u.username === username && u.password === password);
    if (user) {
      setCurrentUser(user);
      return true;
    }
    return false;
  };

  const handleLogout = () => {
    setCurrentUser(null);
  };

  return (
    <div className="App">
      {!currentUser ? (
        <LoginScreen onLogin={handleLogin} />
      ) : (
        <Dashboard user={currentUser} onLogout={handleLogout} isGuest={currentUser.isGuest} />
      )}
    </div>
  );
}

export default App; 